import React from 'react';

const Loader = ({ message = "Loading", isDotNeed = true , size = 50}) => {
  return (
    <div className="flex flex-col items-center">
      <div className="flex items-center gap-2">
        <svg width={size} height={size} viewBox="0 0 240 111" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M26.0637 33.4788C19.1076 33.4788 13.5081 39.1043 13.5081 46.2049V88.389H0V47.1448C0 32.6689 11.632 20.8828 26.0637 20.8828C32.7456 20.8828 39.2977 23.1533 45.4456 29.3139C51.4636 23.2834 58.2754 20.8828 64.813 20.8828C79.2447 20.8828 91.0066 32.6689 91.0066 47.1304V88.3745H77.5129V46.1904C77.5129 39.0898 71.7691 33.4643 64.813 33.4643C57.8569 33.4643 52.2574 39.0898 52.2574 46.1904V88.3745H38.7637V46.1904C38.7637 39.0898 33.0198 33.4643 26.0637 33.4643" fill="#004645" className="dash" style={{ animationDelay: '0s' }} />
          <path d="M158.746 55.0263C158.746 43.3704 150.058 33.4643 138.296 33.4643C126.534 33.4643 117.846 43.3704 117.846 55.0263C117.846 66.6823 126.664 76.5884 138.296 76.5884C149.928 76.5884 158.746 66.6823 158.746 55.0263ZM138.441 89.1699C130.691 89.1699 123.605 86.6247 117.861 82.2139V110.067H104.367V55.0263C104.367 36.1397 119.607 20.8828 138.441 20.8828C157.274 20.8828 172.644 36.1397 172.644 55.0263C172.644 73.913 157.418 89.1699 138.441 89.1699Z" fill="#004645" className="dash" style={{ animationDelay: '0.5s' }} />
          <path d="M226.509 48.605C226.509 40.3041 219.553 33.4783 211.269 33.4783C202.985 33.4783 196.173 40.3041 196.173 48.605V88.374H182.68V0H196.173V25.1774C200.445 22.502 205.655 20.8968 211.269 20.8968C227.173 20.8968 240.003 33.7531 240.003 49.6896V88.3885H226.509V48.6195V48.605Z" fill="#004645" className="dash" style={{ animationDelay: '1s' }} />
        </svg>
      </div>

      <div className="text-gray-333 text-xs">
        {message}
        {isDotNeed && (
          <span className="inline-flex ml-1">
            <span className="animate-pulse" style={{ animationDelay: '0s' }}>.</span>
            <span className="animate-pulse" style={{ animationDelay: '0.15s' }}>.</span>
            <span className="animate-pulse" style={{ animationDelay: '0.3s' }}>.</span>
          </span>
        )}
      </div>

      {/* Inline Keyframes for animation */}
      <style>{`
        @keyframes fadeInDraw {
          0% { opacity: 0; transform: translateY(20px); }
          25% { opacity: 1; transform: translateY(0px); }
          75% { opacity: 1; transform: translateY(0px); }
          100% { opacity: 0; transform: translateY(-20px); }
        }

        .dash {
          opacity: 0;
          animation: fadeInDraw 3s ease-in-out infinite;
        }

        @keyframes pulseDot {
          0%, 100% { opacity: 0.2; }
          50% { opacity: 1; }
        }

        .animate-pulse {
          animation: pulseDot 1s infinite;
        }
      `}</style>
    </div>
  );
};

export default Loader;
